class DisassociateVendorsModalController {
    constructor() {
        // this.buVendorsInfo = this.resolve.buVendorsInfo;
        // this.note = this.resolve.note;
        // this.context = this.resolve.context;
    }
    $onInit() {
        this.buVendorsInfo = this.resolve.buVendorsInfo;
        this.note = this.resolve.note;
        this.context = this.resolve.context;
        this.callbackObject = { callbackType: 'cancel', entity: {} };
    }
    onDisassociateVendors(note) {
        this.callbackObject = { callbackType: 'disassociate', entity: { note: note } };
        this.closeModal();
    }
    closeModal() {
        this.modalInstance.close(this.callbackObject);
    }
    dismissModal() {
        this.modalInstance.dismiss('cancel');
    }
}
// import * as TEMPLATE from './disassociate-vendors-modal.html';
import * as TEMPLATE from 'raw-loader!./disassociate-vendors-modal.html';
export const DisassociateVendorsModalComponent = {
    selector: 'disassociateVendorsModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: DisassociateVendorsModalController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/company/disassociateVendorsModal/disassociate-vendors-modal.html'
    }
};
//# sourceMappingURL=dissassociate-vendors-modal.component.js.map